import React from 'react';

class WbValue extends React.Component {
    render() {
        const { value, classes } = this.props;
        return(<div className={classes.wbValueText}>{value !== undefined ? value : "--"}</div>)
    }
}

export default WbValue;